module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Modern Tabacco1.ba51e57f.jpg";